/* eslint-disable object-curly-newline */
G.OMTsettings = {
  /* configuration for Delta DNA, comment out block or remove to disable */
  DDNA: {
    collect: 'https://collect15528grdnt.deltadna.net/collect/api/',
    engage: 'https://engage15528grdnt.deltadna.net/',
    env: G.BuildEnvironment.production ? '82460680923639031101040657715627' : '82460669990707279764391947015627',
    queueInterval: 1000,
    ftuxVersion: 1, // this should be a integer
  },

  /* configuration for cross promotions */
  crossPromo: {
    promoId: 'pool-party-2',
    showIcon: true,
    worldMapIcon: {
      width: 127,
      height: 127,
    },
  },

  /* configuration for tournaments */
  tournaments: {
    levelLoop: ['tournament_2284', 'tournament_2286', 'tournament_2287', 'tournament_2288', 'tournament_2289', 'tournament_2290'],
    rotationOriginTimestamp: 1603065600000, // unix timestamp (1603065600000, is Monday 00:00:00, October 19th, 2020)
    rotationIntervalHrs: 24 * 7, // total hours for level rotation including the cooldown
    cooldownDurationHrs: 24 * 2, // hours at beginging of rotation
    promotionPosOffset: {
      gingy: {
        y: 9,
      },
      tournamentText: {
        y: 2,
      },
    },
  },

  shoutouts: {
    amountTier0: 3,
    amountTier1: 2,
  },

  adFallback_AskFriend: {
    title: {
      style: { style: 'font-white', fontSize: 40 },
      offsetY: 10,
    },
    graphics: {
      evenColourBg: 0xffca93,
      oddColourBg: 0xfee6c4,
    },
  },

  requestHelp: {
    positionals: {
      useTwoPiecePopup: true,
      maskRadius: 100,
      listOffsetX: -8,
      scrollbarOffsetHeight: -55,
      friendBg3Color: 0xDD7F3B,
    },
  },

  requestMoveHelp: {
    // the index on this array will be the amount of times the current level has been retried - 1
    // if the player has retried the levels more times than there are percentages,
    // we pick the last percentage in the array.
    probabilities: [
      10,
      20,
      30,
      40,
    ],
  },

  friendshipChest: {
    assets: {
      storyChests: [
        { asset: 'storyFriendshipChest1', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest2', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest3', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest4', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest5', background: 'friendshipPolaroidBg' },
        { asset: 'storyFriendshipChest6', background: 'friendshipPolaroidBg1' },
        { asset: 'storyFriendshipChest7', background: 'friendshipPolaroidBg2' },
      ],
    },
    width: 150,
    layoutData: {
      polaroidImageOffsetY: 0,
      messageHardBackground: 0xDD7F3B,
      cardBackground: 0xFFF6D5,
      messageJoined: {
        fontSize: '150px',
        lineSpacing: -20,
        width: 272,
        height: 175,
      },
      bannerMask: {
        x: -301.74,
        y: -9.599999999999994,
        width: 603.48,
        height: 108,
      },
      bannerText: {
        yOffset: -5,
        fontSize: 48,
        offsetDivision: 8,
      },
    },
    maxCards: 50,
  },

  FTUXSettings: {
    runLevelsUpTo: 10,
    gingyPosOffset: {
      y: 1,
    },
  },

  mapChest: {
    startLevel: 10,
    reoccuringLevel: 10,
    formulaChangePoint: 100,
    mapTileSizeInLevels: 13,
    appearanceNodes: [
      [ // level 1 ~ 4
        { x: 271, y: -370 },
        { x: -269, y: -389 },
        { x: -143, y: -466 },
        { x: -50, y: -531 },
        { x: -53, y: -599 },
        { x: -174, y: -617 },
      ],
      [ // 5 ~ 8
        { x: -244, y: -762 },
        { x: 272, y: -806 },
        { x: 211, y: -950 },
        { x: -21, y: -1007 },
        { x: -227, y: -1034 },
        { x: 272, y: -1046 },
      ],
      [ // 9 ~ 13
        { x: -34, y: -1244 },
        { x: -172, y: -1364 },
        { x: 24, y: -1541 },
        { x: -21, y: -1585 },
        { x: 152, y: -1623 },
      ],
    ],
  },

  postcardEvent: { // Data for the postcard event
    unlockData: {
      saveKey: 'oktoberfest2021',
    },
    cardData: {
      extraAssets: [
        { asset: 'tokenEventStamp', anchor: 'top_right', offset: { x: -25, y: 22 } },
      ],
      endCardTextColor: '#cd00ae',
      avatarFrameOffset: {
        x: -8,
        y: -22,
      },
    },
    title: {
      textOffset: { x: 10, y: 30 },
    },
    shop: {
      firstTimeBuyerKey: 'first',
      popupKey: 'popup',
      background: 'eventPostcardShopBg',
      chest: 'eventPostcardShopChest',
      coinbar: 'eventPostcardShopCoinbar',
      specialPopupOffer: 'Special offer',
      popupDimensions: {
        width: 525,
        height: 650,
      },
    },
  },

  // Config for the special shop deal. Similar to eventPostcard but doesn't come with a lot of extra stuff
  specialShopDeal: {
    firstTimePackId: 'summer2020First',
    regularPackId: 'summer2020',
    valueTagMultiplier: 1.1,
    valueTagColours: 0xFF0000,
    coinBarTint: 0xFF1DFD,
    mapIcon: {
      asset: 'summerSaleMapIcon',
      width: 150,
      height: 150,
    },
    saleBannerText: {
      offsetY: 0,
    },
  },

  unlimitedLivesMinCap: 2880, // The maximum amount of minutes you can get when you get get unlimited lives (24 hours)

  tokenEvent: {
    gameBackgroundAsset: 'background_1', // otherwise 'tokenEvent_background'
    // List of level numbers for the event
    levelList: [
      109, 117, 113, 108, 102, 131, 133, 135, 132, 140, 128, 124, 139,
      143, 155, 177, 178, 164, 190, 195, 200, 187, 194, 186, 211, 213,
      215, 230, 232, 225, 234, 228, 239, 263, 290, 313, 332, 357, 358,
      346, 384, 420, 407, 432, 434, 426, 450, 449, 458, 442, 469, 462,
      490, 488, 499, 510, 509, 519, 526, 547, 548, 567, 568, 564, 579,
      593, 609, 619, 640, 667, 710, 720, 707, 714, 706, 716, 721, 729,
      734, 722, 757, 743, 747, 756, 763, 772, 762, 813, 820, 819, 821,
      831, 833, 840, 855, 844, 874, 898, 885, 886],
    mapIcon: {
      layout: {
        bg: {
          x: 0,
          y: 0,
        },
        token: {
          size: 80,
          x: 25,
          y: 0,
        },
        timerBanner: {
          x: 0,
          y: 56,
        },
        timerText: {
          x: 12,
          y: 59,
        },
      },
    },
    // configuration for special event leaderboard
    leaderboardConfig: {
      header: {
        scale: 0.825,
        titleBg: { x: 0, y: -80 },
        title: {
          x: 0, y: 70,
        },
        subTitleBg: { x: 0, y: 150 },
        subTitle: {
          x: 0, y: 150,
        },
      },
      collectMsg: {
        fieldConfig: {
          topOffset: 845,
        },
      },
      tabs: {
        topOffset: 250,
        dividerStroke: { color: 0xff79d5 },
      },
      playBtn: {
        topOffset: 920,
      },
      panel: {
        topOffset: 250,
        userView: {
          icon: {
            offsetY: 0,
          },
          scoreField: {
            fontStyle: {
              fill: '#FFFFFF',
            },
          },
          usernameField: {
            fontStylePlayer: {
              fontSize: '50px',
              style: 'font-orange',
              fill: 'white',
            },
          },
        },
      },
    },
    popupOfferLayout: {
      showTargetOffer: false, // Show offers at all?
      deal: {
        assetsKeys: {
          NON_PAYER_TOKENEVENT: 'tokenEvent_offer_small',
          PAYER_TOKENEVENT: 'tokenEvent_offer_small',
        },
      },
      bg: {
        height: 550,
        outerBgAsset: 'tokenEvent_popup_background',
        outerSlices: null, // background not 9-sliced
        innerOffsetX: -20,
        innerOffsetY: 45,
        innerFrameVisible: false, // we don't have a inner frame for this design
      },
      header: {
        offsetY: 20,
        ribbonOffsetY: 5,
        textOffsetY: 25,
        ribbonConfig: {
          asset: 'tokenEvent_banner',
          sliceRect: null,
          height: 175,
        },
        textConfig: {
          style: { style: 'tokenEvent-eventLevelTitle', lineSpacing: -15, fontSize: '40px' },
          maxWidth: 200,
        },
      },
      multiplier: {
        offsetY: 40,
        offsetX: -40,
        scale: 0.8,
        bgScale: 1.05,
        txt: { offsetX: 0, offsetY: -10, content: 'x5' },
        altBgAsset: 'tokenEvent_shopBadge',
      },
      dealGraphic: {
        offsetX: 5,
      },
      dealCoinbar: {
        tint: 0xff0000,
      },
      playerCoinbar: {
        offsetY: -265,
        scale: 0.8,
      },
      exitConfirm: {
        mascot: { offsetX: -10000 }, // mascot offscreen doesn't fit the layout
        bubble: { offsetX: 0, offsetY: -344 }, // bubble needs to be re-centered with mascot missing
      },
      buyButton: { offsetY: 15 },
      windowHeader: { // config for event window headers. Any window that has text that uses "tokenEvent-eventLevelTitle" style)
        text: {
          x: 0,
          y: -260,
        },
      },
    },
    shopData: {
      shopKey: 'easter',
      firstTimeBuyerKey: 'first',
      background: 'specialdeal_bg',
      chest: 'shop3_specialDeal1',
      coinbar: 'shop3_dealCoinBar',
      specialPopupOffer: 'Summer special offer',
      coinBarTint: 0xFF1DFD,
      coinBarTextStyle: 'eventPostcard-shopCoinText',
    },
    styling: {
      windowTextFill: '#cd00ae', // colour of text in level flow windows
      taskTextFill: '#FFFFFF',
    },
    window_eventLevel: {
      boosterBgWidth: 510,
      postcardsIconAngle: -20,
    },
    windowHeader: {
      text: {
        x: 10,
        y: -265,
      },
    },
    postcard: {
      header: {
        banner: {
          offsetY: 0, // The long background
        },
        title: {
          offsetY: 0, // The container holding text
        },
      },
    },
    gameBoard: {
      topbar: {
        horizontal: 'horizontal-topBarTokenEvent',
      },
      boosterBar: {
        horizontal: 'horizontal-boosterbgTokenEvent',
      },
    },
    windowEventEntry: {
      headerData: {
        text: { // positioned in relation inside .asset (above)
          x: 10,
          y: 30,
        },
      },
      mascot: {
        pos: {
          horizontal: { x: -550 },
        },
      },
    },
  },

  treasureHuntSuper: {
    reward: { // Reward stuff
      sfxFrameTiming: [16, 16, 24], // The frame which the img sequence plays a sound when redeeming prizes
    },
    levelWindow: { // Level window stuff
      mascot: { // Mascot placed around here
        offsetX: 20,
        offsetY: -20,
      },
    },
    worldMapIcon: { // World map icon stuff
      height: 150,
      offsetY: 0,
      timerText: { // Timer text adjustment
        x: 16,
        y: 55,
      },
      timerPos: {
        y: 51,
      },
      animation: [ // Animation works on COOK!
        /* eslint-disable object-curly-newline */
        { asset: 'treasure_hunt_active_layer1', x: 0, y: 0, scaleTween: { x: 1.1, y: 1.1 }, time: 3000, scale: 1, delay: 0 },
        { asset: 'treasure_hunt_active_layer2', x: 0, y: 0, tween: { angle: [10, -10, 10, 0] }, scaleTween: { x: 1.05, y: 1.05 }, time: 2000, scale: 1, delay: 1000 },
        /* eslint-enable object-curly-newline */
      ],
    },
    leaderboardConfig: {
      panel: {
        userView: {
          usernameField: {
            fontStylePlayer: {
              fill: 'white',
            },
            fontStyleOther: {
              fill: '#ffae00',
            },
          },
        },
      },
    },
    promo: {
      mascotOffset: {
        gingy: { y: 21 },
        ginger: { y: 36 },
        chip: { y: 21 },
        cookie: { y: 10 },
        nutmeg: { y: 36 },
        graham: { y: 27 },
      },
    },
    levels: {
      useList: true,
      levelList: [
        109, 117, 113, 108, 102, 131, 133, 135, 132, 140, 128, 124,
        139, 143, 155, 177, 178, 164, 190, 195, 200, 187, 194, 186,
        211, 213, 215, 230, 232, 225, 234, 228, 239, 263, 290, 313,
        332, 357, 358, 346, 384, 420, 407, 432, 434, 426, 450, 449,
        458, 442, 469, 462, 490, 488, 499, 510, 509, 519, 526, 547,
        548, 567, 568, 564, 579, 593, 609, 619, 640, 667, 710, 720,
        707, 714, 706, 716, 721, 729, 734, 722, 757, 743, 747, 756,
        763, 772, 762, 813, 820, 819, 821, 831, 833, 840, 855, 844,
        874, 898, 885, 886],
      startingLevel: 383,
    },
    gameBoard: {
      progressBar: 'treasureHunt_progressBar', // The asset string of a custom progress bar
      progressBarHorizontal: 'treasureHunt_progressBar-horizontal', // The asset string of a custom progress bar horizontal
      horizontal: {
        topBar: {
          offset: { x: 0, y: -32 },
        },
      },
    },
    badgeWindow: {
      counterBg: 'treasureHunt_winNumberBg',
      miniHeader: {
        position: { x: 0, y: 5 },
      },
    },
    eventReminder: {
      bannerData: {
        asset: {
          x: 3,
          y: -63,
        },
        badge: { // Relative to .asset above
          x: 160,
          // y: 37,
          size: 100,
        },
      },
    },
  },

  // ===================================================================
  global: {
    gameName: 'Pool Party',
    defaultFont: 'Lobster',
    leaderboardName: 'completedLevels',
    gameTracking: {
      active: false,
    },
    window: {
      title: {
        textStyle: 'globalTitleStyle',
      },
    },
    popUpFlexBg: {
      width: 680,
      bottomBgHeight: 300,
    },
  },

  elements: {
    annuityReminderIcon: {
      width: 100,
      height: 150,
      offsetY: 25,
    },
    windowNineSlice: {
      slice: {
        top: 112,
        left: 129,
        right: 126,
        bottom: 67,
      },
      whiteSpace: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      inner: {
        top: 100,
        left: 129,
        right: 126,
        bottom: 67,
      },
    },
    leaderboard: {
      disableForBrowsers: ['IE'],
      tabLivesSelected: true,
    },
    gingy: {
      mugshot: {
        x: 78,
        y: 93,
        width: 395,
        height: 395,
      },
      backEyes: {
        x: -4,
        y: -7.5,
      },
      eyes: {
        x: 5,
        y: -25,
      },
      eyelids: {
        x: 5,
        y: -30,
      },
      mouth: {
        x: -2,
        y: 28,
      },
    },
    ginger: { // Sally
      backEyes: {
        x: 7,
        y: -8,
      },
      eyes: {
        x: 5,
        y: -5,
      },
      eyelids: {
        x: 7,
        y: -8,
      },
      mouth: {
        x: 9,
        y: 27,
      },
    },
    chip: { // Bud
      backEyes: {
        x: 43,
        y: -50,
      },
      eyes: {
        x: 50,
        y: -50,
      },
      eyelids: {
        x: 43,
        y: -50,
      },
      mouth: {
        x: 43,
        y: 2,
      },
    },
    cookie: { // Moe
      backEyes: {
        x: 0,
        y: 0,
      },
      eyes: {
        x: 0,
        y: 0,
      },
      eyelids: {
        x: 0,
        y: 0,
      },
      mouth: {
        x: 6,
        y: 11,
      },
    },
    nutmeg: { // Lily
      backEyes: {
        x: 6,
        y: -36,
      },
      eyes: {
        x: 4,
        y: -34,
      },
      eyelids: {
        x: 6,
        y: -36,
      },
      mouth: {
        x: 7,
        y: 23,
      },
    },
    graham: { // Jasper
      backEyes: {
        x: 0,
        y: 0,
      },
      eyes: {
        x: 0,
        y: 0,
      },
      eyelids: {
        x: 0,
        y: 0,
      },
      mouth: {
        x: 7,
        y: 33,
      },
    },
    fancyGingy: {
      mugshot: {
        x: 78,
        y: 93,
        width: 395,
        height: 395,
      },
      backEyes: {
        x: -4,
        y: -7.5,
      },
      eyes: {
        x: 5,
        y: -25,
      },
      eyelids: {
        x: 5,
        y: -30,
      },
      mouth: {
        x: -2,
        y: 28,
      },
    },
    treasureHuntgingy: {
      backEyes: {
        x: -3,
        y: -14,
      },
      eyes: {
        x: -1,
        y: -17,
      },
      eyelids: {
        x: -3,
        y: -14,
      },
      mouth: {
        x: -4,
        y: 21,
      },
    },
    treasureHuntginger: {
      backEyes: {
        x: 13,
        y: -2,
      },
      eyes: {
        x: 11,
        y: 0,
      },
      eyelids: {
        x: 13,
        y: -2,
      },
      mouth: {
        x: 13,
        y: 34,
      },
    },
    treasureHuntchip: {
      backEyes: {
        x: 46,
        y: -11,
      },
      eyes: {
        x: 53,
        y: -11,
      },
      eyelids: {
        x: 46,
        y: -11,
      },
      mouth: {
        x: 46,
        y: 40,
      },
    },
    treasureHuntcookie: {
      backEyes: {
        x: 0,
        y: 0,
      },
      eyes: {
        x: 0,
        y: 0,
      },
      eyelids: {
        x: 0,
        y: 0,
      },
      mouth: {
        x: 7,
        y: 23,
      },
    },
    treasureHuntnutmeg: {
      backEyes: {
        x: 6,
        y: -25,
      },
      eyes: {
        x: 5,
        y: -22,
      },
      eyelids: {
        x: 6,
        y: -25,
      },
      mouth: {
        x: 6,
        y: -1,
      },
    },
    treasureHuntgraham: {
      backEyes: {
        x: 0,
        y: 0,
      },
      eyes: {
        x: 0,
        y: 0,
      },
      eyelids: {
        x: 0,
        y: 0,
      },
      mouth: {
        x: 12,
        y: 36,
      },
    },
    characterAssets: {
      gingy: {
        yBottom: 175,
      },
      ginger: {
        yBottom: 199,
      },
      nutmeg: {
        yBottom: 198,
      },
      cookie: {
        backEyes: null,
        eyes: null,
        eyelids: null,
        yBottom: 172,
      },
      chip: {
        yBottom: 165,
      },
      graham: {
        yBottom: 198,
      },
      fancyGingy: {
        yBottom: 183,
      },
      treasureHuntgingy: {
        yBottom: 116,
      },
      treasureHuntginger: {
        mouth_closed: 'ginger_mouth_closed',
        mouths: [
          'ginger_mouth_closed',
          'ginger_mouth_open',
          'ginger_mouth_surprised',
        ],
        yBottom: 116,
      },
      treasureHuntnutmeg: {
        body: 'treasureHuntnutmeg_body',
        eyes: 'nutmeg_eyes',
        eyelids: 'nutmeg_eyelids',
        mouth_closed: 'nutmeg_mouth_closed',
        mouths: [
          'nutmeg_mouth_closed',
          'nutmeg_mouth_open',
          'nutmeg_mouth_surprised',
        ],
        yBottom: 116,
      },
      treasureHuntcookie: {
        backEyes: null,
        eyes: null,
        eyelids: null,
        mouth_closed: 'cookie_mouth_closed',
        mouths: [
          'cookie_mouth_closed',
          'cookie_mouth_open',
          'cookie_mouth_surprised',
        ],
        yBottom: 100,
      },
      treasureHuntchip: {
        backEyes: 'treasureHuntchip_eyes_back',
        eyelids: 'treasureHuntchip_eyelids',
        mouth_closed: 'chip_mouth_closed',
        mouths: [
          'chip_mouth_closed',
          'chip_mouth_open',
          'chip_mouth_surprised',
        ],
        yBottom: 85,
      },
      treasureHuntgraham: {
        mouth_closed: 'graham_mouth_closed',
        mouths: [
          'graham_mouth_closed',
          'graham_mouth_open',
          'graham_mouth_surprised',
        ],
        yBottom: 140,
      },
    },
    badges: { // Each key is the badge name. The data inside is the frame offset that is used with OMT_UI_AvatarWithFrameOffset
      /* eslint-disable object-curly-newline */
      treasureHuntGoldgingy: { x: 0, y: -1, scale: 1.58 },
      treasureHuntSilvergingy: { x: 0, y: -1, scale: 1.6 },
      treasureHuntBronzegingy: { x: 0, y: 0, scale: 1.6 },
      treasureHuntBasicgingy: { x: 0, y: -1, scale: 1.55 },
      treasureHuntGoldginger: { x: 0, y: -1, scale: 1.58 },
      treasureHuntSilverginger: { x: 0, y: -1, scale: 1.6 },
      treasureHuntBronzeginger: { x: 0, y: 0, scale: 1.6 },
      treasureHuntBasicginger: { x: 0, y: -1, scale: 1.55 },
      treasureHuntGoldchip: { x: 0, y: -1, scale: 1.58 },
      treasureHuntSilverchip: { x: 0, y: -1, scale: 1.6 },
      treasureHuntBronzechip: { x: 0, y: 0, scale: 1.6 },
      treasureHuntBasicchip: { x: 0, y: -1, scale: 1.55 },
      treasureHuntGoldnutmeg: { x: 0, y: -1, scale: 1.58 },
      treasureHuntSilvernutmeg: { x: 0, y: -1, scale: 1.6 },
      treasureHuntBronzenutmeg: { x: 0, y: 0, scale: 1.6 },
      treasureHuntBasicnutmeg: { x: 0, y: -1, scale: 1.55 },
      treasureHuntGoldcookie: { x: 0, y: -1, scale: 1.58 },
      treasureHuntSilvercookie: { x: 0, y: -1, scale: 1.6 },
      treasureHuntBronzecookie: { x: 0, y: 0, scale: 1.6 },
      treasureHuntBasiccookie: { x: 0, y: -1, scale: 1.55 },
      treasureHuntGoldgraham: { x: 0, y: -1, scale: 1.58 },
      treasureHuntSilvergraham: { x: 0, y: -1, scale: 1.6 },
      treasureHuntBronzegraham: { x: 0, y: 0, scale: 1.6 },
      treasureHuntBasicgraham: { x: 0, y: -1, scale: 1.55 },
      /* eslint-enable object-curly-newline */
    },
    buttonNineSlice: {
      layers: { // Default layers for buttons at regular size
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_base',
        largeDetail: ['buttons/btn_pattern1'],
        highlights: 'buttons/btn_highlight',
      },
      smallSlice: { // Default slice for small buttons
        left: 22,
        right: 21,
        top: 26,
        bottom: 20,
      },
      largeDetail: { // Default slice for large/detailed buttons
        left: 39,
        right: 42,
        top: 45,
        bottom: 37,
      },
    },
    buttonTintColours: { // Button nine-slice colour definitions
      green: 0x27fa00,
      blue: 0x3d9bff,
      red: 0xff0000,
      purple: 0xc73eff,
      orange: { // Provides its own layer
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_orange',
        largeDetail: ['buttons/btn_orangePattern'],
      },
      gray: 0x888888,
      lightGreen: {
        shadow: 'buttons/btn_shadow',
        base: 'buttons/btn_lightGreen',
        largeDetail: ['buttons/btn_pattern1'],
      },
    },
    chestPositioning: {
      inGame: {
        bottom: { x: 0, y: 0 },
        top: { x: -32, y: -15 },
        glow: { x: 0, y: -20 },
      },
      closed: {
        top: {
          x: 0,
          y: -42,
        },
      },
      opened: {
        bottom: {
          x: 0,
          y: 0,
        },
        top: {
          x: 37,
          y: -65,
        },
        glow: {
          x: 3,
          y: -48,
        },
      },
    },
    chestShuffle: {
      charSizeScale: 1.3,
    },
    tutorialMsg: {
      fontSize: 45,
      lineSpacing: -17,
    },
    LossAversionWheelGroup: {
      useVillainTitles: true,
    },
    dailyReward: {
      title: {
        x: 0,
        y: -285,
        style: 'DailyRewardTitle',
      },
      comeBackTxt: {
        lineSpacing: -20,
      },
    },
    dailyIcon: {
      height: 90,
    },
    dailyChallengeIcon: {
      height: 110,
      width: 175,
    },
    dailyMission: {
      ribbonText: {
        yPos: 45,
      },
    },
    deconstructMsg: {
      tournamentTaunt: {
        aheadFriend: {
          x: 124,
          y: 135,
          angle: 0,
          avatar: {
            scale: 1.5,
            x: -26,
            y: -40,
            angle: -20,
          },
        },
        midFriend: {
          x: -78,
          y: 107,
          angle: 0,
          avatar: {
            scale: 1.25,
            x: 6,
            y: -11,
            angle: 23,
          },
        },
        lastFriend: {
          x: -203,
          y: -14,
          angle: 0,
          avatar: {
            scale: 1,
            x: -15,
            y: -20,
            angle: -10,
          },
        },
        text: {
          x: 0,
          y: -238,
          angle: 0,
        },
        trophy: { // Relative to aheadFriend
          x: 212,
          y: -10,
          angle: 0,
        },
        sparkles: [ // Relative to the trophy
          { x: 96, y: -21, angle: 0 },
          { x: -81, y: -10, angle: 0 },
          { x: 64, y: -42, angle: 0 },
          { x: -104, y: 25, angle: 0 },
          { x: 18, y: 71, angle: 0 },
          { x: -41, y: -84, angle: 0 },
        ],
      },
    },
    mockFacebookFriends: {
      friends: [
        { name: 'Gingy', image: 'friendshipGingy' },
        { name: 'Bubbles', image: 'friendshipBubbles' },
        { name: 'Finn', image: 'friendshipFinn' },
        { name: 'Dolly', image: 'friendshipDolly' },
        { name: 'Shelly', image: 'friendshipShelly' },
        { name: 'Spike', image: 'friendshipSpike' },
      ],
    },
    giftUI: {
      sideGingy: {
        txt: {
          lineSpacing: -15,
          fontSize: '42px',
        },
      },
    },
    highscoreBeaten: {
      continueBtn: {
        x: 0,
        y: 245,
      },
    },
    checkedIconPast: {
      x: 35,
      y: 15,
    },
    checkedIcon: {
      x: 35,
      y: 15,
    },
    mapGift: {
      timer: {
        y: 55,
      },
      width: 150,
    },
    worldMapButtonOrder: {
      vertical: {
        left: ['tournament', 'specialShopDeal', 'tokenEvent', 'treasureHunt'],
        right: ['mapGiftannuityreminder', 'dailyChallenge', 'dailyIcon', 'friendshipChest', 'xPromo'],
        alignXDynamically: true,
      },
      horizontal: {
        left: ['xPromo', 'tokenEvent'],
        right: ['mapGiftannuityreminder', 'dailyChallenge', 'dailyIcon', 'friendshipChest', 'tournament', 'specialShopDeal', 'treasureHunt'],
        alignXDynamically: true,
      },
    },
    worldMap: {
      mapScale: 0.75,
      allowHScrolling: false,
      bubbleScale: 0.7,
      tiles: [
        'Map_path_tile3',
        'Map_path_tile0',
        'Map_path_tile1',
        'Map_path_tile2',
      ],
      tilePropCenter: {
        vertical: [
          [{ x: -145, y: 15, pool: 'left' }, { x: -300, y: -300, pool: 'leftFiller' }],
          [{ x: 145, y: 45, pool: 'right' }, { x: 350, y: -300, pool: 'rightFiller' }],
          [{ x: -145, y: 35, pool: 'behindRiver|left' }, { x: -150, y: 120, pool: 'aboveRiver' }, { x: -300, y: -300, pool: 'leftFiller' }],
          [{ x: 185, y: 25, pool: 'right' }, { x: 350, y: -300, pool: 'rightFiller' }],
        ],
        horizontal: [
          [{ x: -210, y: 15, pool: 'left' }],
          [{ x: 220, y: 35, pool: 'right' }],
          [{ x: -170, y: 15, pool: 'behindRiver|left' }, { x: -150, y: 100, pool: 'aboveRiver' }],
          [{ x: 220, y: 35, pool: 'right' }],
        ],
      },
      riverTileExtra: {
        index: 2, // The index on the tiles array
        offset: [{ x: 309, y: 42 }, { x: 419, y: 77 }, { x: 471, y: 154 }, { x: 404, y: 226 }],
      },
      levelNodePositions: [ // for each tile, from the bottom
        [{ x: 364, y: 45 }, { x: 449, y: 85 }, { x: 483, y: 157 }, { x: 438, y: 229 }],
        [{ x: 353, y: 44 }, { x: 255, y: 86 }, { x: 184, y: 153 }, { x: 218, y: 230 }],
        [{ x: 300, y: 42 }, { x: 400, y: 82 }, { x: 473, y: 144 }, { x: 416, y: 222 }],
        [{ x: 317, y: 23 }, { x: 256, y: 84 }, { x: 236, y: 161 }, { x: 276, y: 241 }],
      ],
      mailboxPositions: [
        [{ x: 265, y: 170, scale: -1 }],
        [{ x: 406, y: 245, scale: 1 }],
        [{ x: 147, y: 185, scale: -1 }],
        [{ x: 392, y: 209, scale: 1 }],
      ],
      chestShufflePositions: [
        [{ x: 266, y: 166, scale: -1 }],
        [{ x: 411, y: 212, scale: 1 }],
        [{ x: 148, y: 155, scale: -1 }],
        [{ x: 401, y: 188, scale: 1 }],
      ],
      sagaMapChestPositions: [
        [{ x: 264, y: 122, scale: -1 }],
        [{ x: 406, y: 206, scale: 1 }],
        [{ x: 147, y: 135, scale: -1 }],
        [{ x: 394, y: 169, scale: 1 }],
      ],
      rewardPerTile: [
        'mailbox',
        'chestMap',
        'chestShuffle',
        'chestMap',
        '',
      ],
      riverTint: [
        0xb4ffde,
        0xffe2fd,
        0xc2f1ff,
        0xffef91,
        0xebcbff,
      ],
      grassColour: 0x8dd415,
    },
    worldMapLvlButton: {
      lvlNrText: {
        style: 'worldMapLvlButtonText',
      },
      closedMsg: {
        style: 'lvlButtonCloseMessage',
        x: 560,
        y: 204.5,
        width: 186,
        height: 152,
      },
    },
    Window_FortuneCookie: {
      categories: {
        funny: {
          index: 1,
          enabled: true,
        },
        prediction: {
          index: 3,
          enabled: true,
        },
        love: {
          index: 2,
          enabled: true,
        },
        wisdom: {
          index: 4,
          enabled: true,
        },
        game: {
          index: 0,
          enabled: false,
        },
      },
      elementLayouts: {
        bannerTextOffset: { x: 0, y: 0 },
        yPos: { // range of y-positions (for responsiveness)
          shareBannerGroup: { min: -375, max: -460 },
          msgGroup: { min: -212, max: -242 },
          msgImgGroup: { min: 90, max: 100 },
          shareBtn: { min: 395, max: 460 },
        },
        scaling: { // range of scale factors (for responsiveness)
          msgGroup: { min: 0.84, max: 1 },
          msgImgGroup: { min: 0.9, max: 1.05 },
        },
      },
      avatarLayout: {
        funny: {
          x: -123,
          y: -36,
          width: 167,
          height: 167,
          angle: -6,
        },
        prediction: {
          x: 1,
          y: -47,
          width: 192,
          height: 192,
          angle: -6,
        },
        love: {
          x: -121,
          y: -34,
          width: 170,
          height: 170,
          angle: -6,
        },
        wisdom: {
          x: 97,
          y: -40,
          width: 172,
          height: 172,
          angle: 6,
        },
        game: { // unused
          x: 20,
          y: -22,
          width: 90,
          height: 90,
          angle: 15,
        },
      },
      tagSymbolOnly: false,
      tagPosition: {
        x: 45,
        y: -3,
      },
    },
    MsgFortuneCookie: {
      avatarLayout: {
        funny: {
          x: 497,
          y: 110,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        prediction: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        love: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        wisdom: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
        game: {
          x: 496,
          y: 113,
          width: 138,
          height: 138,
          angle: 5.62,
        },
      },
    },
    CandyType_FortuneCookie: {
      timerPosition: {
        x: 24,
        y: 11,
      },
    },
    RealMoneyWheel: {
      gingy: {
        x: 0,
        y: 270,
        bobbingAnim: true,
        bobbingAnimConfig: {
          vDisplacement: 10,
          hDisplacement: 0,
          cycleLength: 7500, // ms
        },
      },
    },

    // config overrides for wheels / wheel items
    wheelConfigs: {
      dailyPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 33 }, offset: { y: 4 } },
            icon: { scale: 0.65 },
          },
          COINS_SPECIAL: {
            text: { style: { fontSize: 29 }, offset: { y: 2 } },
            icon: { scale: 0.65 },
          },
          BOOSTER: {
            text: { style: { fontSize: 33 }, offset: { y: 4 } },
          },
        },
      },
      lossAversionPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 40 } },
          },
        },
      },
      requestHelpPrizeWheel: {
        spinner: { wheelSegments: 24 }, // amount of pegs
        itemConfigOverrides: {
          COINS: {
            text: { style: { fontSize: 40 } },
          },
        },
      },
      realMoneyPrizeWheel: {
        itemConfigOverrides: {
          COINS: {
            text: {
              style: 'realMoneyWheel-coinTextGold',
              offset: { x: 125, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 145, y: 0 },
            },
          },

          COINS_SPECIAL: {
            text: {
              style: 'realMoneyWheel-coinTextGoldSpecial',
              offset: { x: 125, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 145, y: 0 },
            },
          },

          COINS_PLAT: {
            text: {
              style: 'realMoneyWheel-coinTextPlat',
              offset: { x: 145, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 165, y: 0 },
            },
          },

          COINS_SPECIAL_PLAT: {
            text: {
              style: 'realMoneyWheel-coinTextSpecialPlat',
              offset: { x: 145, y: 0 },
            },
            icon: {
              scale: 0.5,
              offset: { x: 165, y: 0 },
            },
          },
        },
      },
    },
    UI_MapPanel: {
      settingsMenu: {
        vertical: {
          x: 280,
          y: 40,
          size: 68,
        },
      },
    },
    Window_friendOvertaken: {
      titleTxt: {
        style: 'friendOvertaken',
      },
    },
    Window_mysteryGift: {
      titleOffsetY: 5,
    },
    Window_highscoreBeaten: {
      titleTxt: {
        style: 'highscoreBeaten',
      },
    },
    Window_crossPromo: {
      titleTxt: {
        x: 0,
        y: -240,
      },
      continueBtn: {
        x: 0,
        y: 250,
      },
      continueBtnTxt: {
        x: 0,
        y: 0,
        style: 'XPromoContinue',
      },
    },
    Window_giveUp: {
      levelTxt: {
        style: 'giveUpLevelTxt',
      },
    },
    Window_botOptIn: {
      titleTxt: {
        style: 'BotOptInTitle',
      },
    },
    Window_Brag: {
      closeButton: { offsetX: 0, offsetY: 0 },
      bannerImage: {
        fullscreen: 'store_bg',
        offsets: { x: 0, y: 15 },
        text: { y: 7, width: 0.65, height: 0.9 },
        scale: 0.9,
      },
      content: {
        friendsLayout: { // double avatar layout
          fullscreen: {
            x: 0,
            y: -40,
            minWidth: 600,
            maxWidth: 600,
          },
          friendAvatar: {
            avatarSize: 125,
            x: 86,
            y: 55,
            angle: 12,
          },
          playerAvatar: {
            avatarSize: 125,
            x: -103,
            y: -52,
            angle: -7,
          },
        },
        soloLayout: { // single avatar layout
          fullscreen: {
            x: 0,
            y: 10,
            minWidth: 750,
            maxWidth: 820,
          },
          playerAvatar: {
            avatarSize: 142,
            x: -31,
            y: -9,
            angle: -6,
          },
        },
        skipTutorialLayout: { // for first time users winning a challenge
          fullscreen: {
            x: 0,
            y: 50,
            minWidth: 0,
            maxWidth: 650,
          },
          imageScale: 0.65,
          playerAvatar: {
            avatarSize: 100,
            x: -100,
            y: -50,
            angle: 0,
          },
        },
      },
    },
    Window_notEnoughLives: {
      livesNrTxt: {
        x: 0,
        y: -60,
      },
      coinsTxt: {
        x: 10,
        y: -279,
        style: 'NotEnoughLivesCoins',
      },
      buyLifeButton_coinTxt: {
        style: 'NotEnoughLivesBuyCoin',
      },
    },
    Window_taskSlider: {
      taskTxt: {
        horizontalY: 30,
        y: 58,
        style: {
          style: 'taskText',
        },
      },
      goal: {
        style: {
          style: 'taskGoal',
        },
      },
    },
    Window_newsHomeScreen: {
      button: {
        shouldPulse: true,
        x: 0,
        y: 215,
      },
      continueBtn: {
        x: 0,
        y: 295,
      },
      continueBtnTxt: {
        x: 0,
        y: 295,
      },
    },
    Window_shop2: {
      isShowing3hGift: true,
      scrollHeightOffset: -10,
    },
    Window_shop3: {
      regularDealFrameSlice: { // Slices for the frame
        top: 62,
        bottom: 68,
        right: 39,
        left: 61,
      },
      headerSlice: { // Nineslice for header pieces
        top: 37,
        left: 94,
        bottom: 37,
        right: 103,
      },
      specialDealFrameExtra: {
        offsetX: 0,
        offsetY: 0,
        topOfFrame: 45,
        bottomOfFrame: 158,
      },
      specialDealFrameSlice: { // The slices for the special deal frames
        top: 116,
        bottom: 120,
        left: 104,
        right: 109,
      },
      specialDealRibbonSize: { // Size of ribbion
        height: 58,
      },
      specialDealRibbonSlice: { // The slices for the ribbon
        top: 29,
        bottom: 29,
        left: 55,
        right: 55,
      },
      specialDealBoosterBoxSlice: { // The slices for the booster box details
        top: 40,
        bottom: 35,
        left: 43,
        right: 49,
      },
      tagBaseMultipler: 1,
      regularDealTagIndex: 2,
      maxSpecialSlots: 4,
      specialDealTintData: [ // Tint data on the layout
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox',
            coinBar: {
              tint: 0x1E88FF,
              textStyle: 'shop3-boosterTextStyle0',
            },
          },
          valueTagTint: 1,
        },
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox',
            coinBar: {
              tint: 0x3FB116,
              textStyle: 'shop3-boosterTextStyle1',
            },
          },
          valueTagTint: 1,
        },
        {
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox',
            coinBar: {
              tint: 0xFF09B0,
              textStyle: 'shop3-boosterTextStyle2',
            },
          },
          valueTagTint: 0,
        },
        { // FTU
          boosterBox: {
            asset: 'shop3_specialDealBoosterBoxFTU',
            coinBar: {
              tint: 0xFF00FC,
              textStyle: 'shop3-boosterTextStyle3',
            },
          },
          valueTagTint: 1,
        },
        { // Weekend deal
          boosterBox: {
            asset: 'shop3_specialDealBoosterBox4',
            coinBar: {
              tint: 0xba0d03,
              textStyle: 'shop3-boosterTextStyle4',
            },
          },
          valueTagTint: 3,
        },
        { // Annuity
          boosterBox: {
            asset: 'shop3_annuityBoosterBox',
            coinBar: {
              tint: 0xF62E4A,
              textStyle: 'font-white',
            },
          },
          valueTagTint: 0,
        },
      ],
      weekendTimerArea: {
        x: 102,
        y: 60,
        width: 65,
        height: 45,
      },
    },
    Window_treasureHuntEvent: {
      bgSize: 300,
    },
    Window_timedTargetedOffer: {
      vertical: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetX: 0,
          offsetY: -435,
          scale: 0.95,
        },
        dealCoinbar: {
          textOffsetY: -3,
        },
        multiplier: {
          offsetY: 15,
          offsetX: -22,
          scale: 0.95,
          bgScale: 1.05,
          txt: { offsetX: 1, offsetY: 1 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetY: -12,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: 100,
          ribbonOffsetY: 5,
          timerOffsetY: -11,
          textOffsetY: 30,
        },
        exitConfirm: {
          mascot: {
            offsetX: -175,
            offsetY: 8,
            scale: 0.8,
            character: 'ginger',
          },
          bubble: { offsetX: 320, offsetY: -100 },
        },
        buyButton: { offsetY: 280 },
        boosterIcon: { labelPaddingY: -10 },
        unlimitedLivesIcon: { labelPaddingY: 5 },
      },
      horizontal: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetX: -345,
          offsetY: -220,
          scale: 1,
        },
        dealCoinbar: {
          textOffsetY: -3,
        },
        multiplier: {
          offsetY: 12,
          offsetX: -812,
          scale: 1,
          bgScale: 1.1,
          txt: { offsetX: 0, offsetY: 0 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetX: -240,
          innerOffsetY: 23,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: 100,
          ribbonOffsetY: 5,
          timerOffsetY: -11,
          textOffsetY: 30,
        },
        exitConfirm: {
          mascot: {
            offsetX: -425,
            offsetY: 20,
            scale: 1,
            character: 'ginger',
          },
          bubble: { offsetX: 0, offsetY: -300 },
        },
        buyButton: { offsetY: 350 },
        boosterIcon: { labelPaddingY: -10 },
        unlimitedLivesIcon: { labelPaddingY: 5 },
      },
    },
    Window_oneTimeTargetedOffer: {
      vertical: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetY: -240,
        },
        dealCoinbar: {
          scale: 1.2,
          fontSize: 36,
          tint: 0xFF4210,
        },
        multiplier: {
          offsetY: 48,
          offsetX: -15,
          scale: 1,
          bgScale: 1,
          txt: { offsetX: 1, offsetY: -2 },
        },
        bg: {
          height: 550,
          outerBgAsset: 'specialdeal_bg',
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetY: -12,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: 20,
          ribbonOffsetY: 3,
          textOffsetY: 0,
          ribbonConfig: {
            asset: 'shop3_dealRibbon2',
          },
        },
        exitConfirm: {
          mascot: { offsetX: 42, offsetY: 108 },
          bubble: { offsetX: 15, offsetY: -340 },
        },
        buyButton: { offsetY: -11 },
      },
      horizontal: {
        deal: {
          assetsKeys: {
            moneyOnly: 'shop3_specialDeal2',
            fewBoosters: 'shop3_specialDeal1',
            manyBoosters: 'shop3_specialDeal0',
          },
        },
        playerCoinbar: {
          offsetY: -260,
        },
        dealCoinbar: {
          scale: 1.2,
          fontSize: 36,
          tint: 0xFF4210,
        },
        multiplier: {
          offsetY: 12,
          offsetX: -812,
          scale: 1,
          bgScale: 1.1,
          txt: { offsetX: 0, offsetY: 0 },
        },
        bg: {
          height: 550,
          outerSlices: {
            left: 145, right: 149, top: 221, bottom: 139,
          },
          innerSlices: {
            left: 72, right: 72, top: 66, bottom: 66,
          },
          innerOffsetX: -240,
          innerOffsetY: 23,
          innerTint: 0xffb20d,
        },
        header: {
          offsetY: -2,
          ribbonOffsetY: 5,
          textOffsetY: 2,
          ribbonConfig: {
            asset: 'shop3_dealRibbon2',
          },
        },
        exitConfirm: {
          mascot: {
            offsetX: 1045,
            offsetY: 5,
            scaleX: -0.75,
            scaleY: 0.75,
          },
          bubble: { offsetX: 563, offsetY: -180 },
        },
        buyButton: { offsetY: -1 },
      },
    },

    Window_noAdsPopup: {
      vertical: {
        window: {
          x: 0,
          y: 0,
        },
        title: {
          x: 0,
          y: -284,
          text: 'Did you know?',
          style: 'noAdsPopup-title',
          maxWidth: 340,
        },
        background: {
          width: 560,
          height: 650,
        },
        dealChest: {
          x: 110,
          y: 170,
          scale: 0.9,
        },
        gingy: {
          x: -130,
          y: 182,
          scale: 0.8,
        },
        adCrossed: {
          x: 0,
          y: -5,
          scale: 0.475,
        },
        message: {
          x: 0,
          y: -230,
          maxWidth: 448,
          maxHeight: 165,
          text: 'You can remove forced ads forever by making any purchase in the coins store',
          style: {
            style: 'noAdsPopup-message',
            fontSize: 36,
          },
        },
        continueButton: {
          x: 0,
          y: 320,
          width: 230,
          height: 90,
          text: 'Continue',
          style: {
            style: 'font-white',
            fontSize: 64,
          },
          pulse: 1.05,
        },
      },

      horizontal: {
        window: {
          x: 0,
          y: 100,
        },
        title: {
          x: 0,
          y: -355,
          text: 'Did you know?',
          style: 'noAdsPopup-title',
          maxWidth: 500,
        },
        background: {
          width: 1300,
          height: 800,
        },
        dealChest: {
          x: 380,
          y: 160,
          scale: 1.55,
        },
        gingy: {
          x: -390,
          y: 175,
          scale: 1.4,
        },
        adCrossed: {
          x: 0,
          y: 25,
          scale: 0.95,
        },
        message: {
          x: 0,
          y: -290,
          maxWidth: 1000,
          maxHeight: 200,
          text: 'You can remove forced ads forever by making any purchase in the coins store',
          style: {
            style: 'noAdsPopup-message',
            fontSize: 64,
          },
        },
        continueButton: {
          x: 0,
          y: 300,
          width: 275,
          height: 130,
          text: 'Continue',
          style: {
            style: 'font-white',
            fontSize: 72,
          },
          pulse: 1.05,
        },
      },
    },

    UI_PointsCounter: {
      text: {
        style: 'UIPointsTxt',
      },
    },
    UI_BoosterButton: {
      amount: {
        style: 'UIBoosterAmount',
      },
    },
    UI_StartBoosterButton: {
      amountTxt: {
        style: 'UIStartBoosterAmount',
      },
    },
    taskCollectPanels: {
      amount: {
        style: {
          style: 'font-white',
        },
      },
    },
    UI_GoalPanelCollect: {
      panelNr: {
        style: 'UIGoalPanelNr',
      },
    },
    UI_GoalPanelPoints: {
      labelTxt: {
        style: 'UIGoalPanelPointsLabel',
      },
      pointsCounter: {
        style: 'UIGoalPanelPointAmount',
      },
    },
    UI_ProgressBarHorizontal: {
      scale: 0.95,
      offset: {
        x: 0,
        y: -3,
      },
    },
    gifts: {
      shineOffsetY: -55,
      useGiftTrim: false,
    },
    // these colors use { GIFT_COLORS } from "../../js/Elements/Windows/GiftUI/GiftGraphic"
    dailyRewardCalendar: {
      doubleable: true,
      days: [
        // top left
        {
          gifts: [['coin', 200]],
          boxIcon: [],
        },
        // top middle
        {
          gifts: [['booster#2', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [0, 0],
              useFullGift: true,
            },
          ],
        },
        // top right
        {
          gifts: [['booster#7', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [15, -16],
              scale: [0.85, 0.85],
              useFullGift: true,
            },
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [-18, 10],
              scale: [0.9, 0.9],
            },
          ],
        },
        // middle left
        {
          gifts: [['booster#5', 1]], // #5/#6 fixed in dailyRewardMgr
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Green',
              pos: [20, -10],
              scale: [0.9, 0.9],
            },
            {
              giftType: 1,
              boxTint: 'Light_Blue',
              ribbonTint: 'Purple',
              pos: [-20, 8],
              scale: [0.85, 0.85],
            },
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Yellow',
              pos: [15, 20],
              scale: [0.7, 0.7],
            },
          ],
        },
        // middle center
        {
          gifts: [['booster#1', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [20, -10],
              scale: [0.8, 0.8],
              useFullGift: true,
            },
            {
              giftType: 2,
              boxTint: 'Green',
              ribbonTint: 'Pink',
              pos: [-25, 7],
              scale: [1, 1],
            },
            {
              giftType: 2,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [25, 20],
              scale: [0.7, 0.7],
            },
          ],
        },
        // middle right
        {
          gifts: [['booster#8', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Green',
              pos: [0, -14],
              scale: [0.85, 0.85],
            },
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Light_Blue',
              pos: [-36, 5],
              scale: [0.8, 0.8],
            },
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Pink',
              pos: [33, 5],
              scale: [0.75, 0.75],
            },
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Yellow',
              pos: [-5, 25],
              scale: [0.8, 0.8],
            },
          ],
        },
        // bottom
        {
          gifts: [
            ['booster#5', 1], // #5/#6 fixed in dailyRewardMgr
            ['booster#8', 1],
          ],
          boxIcon: [
            // leftmost
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Pink',
              pos: [-90, -20],
              scale: [0.75, 0.75],
            },
            // rightmost
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Pink',
              pos: [90, -20],
              scale: [0.75, 0.75],
            },
            // second from right
            {
              giftType: 1,
              boxTint: 'Purple',
              ribbonTint: 'Yellow',
              pos: [55, -10],
              scale: [0.8, 0.8],
              useFullGift: true,
            },
            // second frm left
            {
              giftType: 1,
              boxTint: 'Pink',
              ribbonTint: 'Light_Blue',
              pos: [-55, -10],
              scale: [0.8, 0.8],
            },
            // center
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [0, 0],
              scale: [1.2, 1.2],
            },
          ],
        },
      ],
    },

    // Super hard update element config
    superhard: {
      window_level: {
        hard_popup: {
          top: 322,
          bottom: 290,
          left: 285,
          right: 250,
        },
        super_hard_popup: {
          top: 319,
          bottom: 293,
          left: 250,
          right: 285,
        },
        hard_tint: 0xEBB5FF,
        super_hard_tint: 0xFFBEBF,
        villainsXOffset: -60,
        villainsYOffset: 0,
      },
      window_dailyChallenge: {
        villainsXOffset: 0,
        villainsYOffset: -50,
      },
      speech_bubble: {
        hard_bubble: {
          top: 20,
          bottom: 15,
          left: 58,
          right: 55,
        },
        super_hard_bubble: {
          top: 54,
          bottom: 55,
          left: 107,
          right: 75,
        },
        gingy_bubble: {
          top: 0,
          bottom: 0,
          left: 161,
          right: 113,
        },
      },
      gingyBubble: {
        offsetX: 0.01,
      },
      window_levelFailed: {
        levelTxtStyle: {
          style: 'font-white',
          fontSize: '60px',
        },
      },
      bubbleTipPos: {
        hard: {
          'top-right': {
            x: 250,
            y: -40,
          },
          'top-left': {
            x: 320,
            y: -30,
          },
          right: {
            x: 525,
            y: 120,
          },
          left: {
            x: -45,
            y: 110,
          },
        },
        superhard: {
          'top-right': {
            x: 250,
            y: -40,
          },
          'top-left': {
            x: 320,
            y: -30,
          },
          right: {
            x: 545,
            y: 150,
          },
          left: {
            x: -75,
            y: 150,
          },
        },
      },
      villain_speech: {
        hard_win: 'Ow, %mainVillain% has a tummy ache. Need a break!',
        super_hard_win: 'Yuck, there\'s no good food here anyway!',
        hard_oom: 'Yum, %mainVillain% isn\'t even full yet!',
        super_hard_oom: 'Come on, time for seconds!',
        hard_lose: '%mainVillain% took a big bite out of this Garden!',
        super_hard_lose: 'Over already? %mainVillain% and %sideVillain% still so hungry!',
        hard_mystery_gift: '%mainVillain% is going to eat everything in sight!',
        super_hard_mystery_gift: '%mainVillain% and %sideVillain% are getting ready for dessert!',
        dailyChallengeOOM0: 'This meal was too quick! Come on!',
        dailyChallengeOOM1: 'That wasn\'t even a full meal!',
        dailyChallengeOOM2: 'Are you gonna finish that?',
        dailyChallengeFail0: '%mainVillain% and %sideVillain% are the best! ',
        dailyChallengeFail1: 'Haha! Get the toothpicks!',
        dailyChallengeFail2: 'This too easy for %mainVillain% and %sideVillain%!',
        dailyChallengeWin0: 'These plants taste gross!',
        dailyChallengeWin1: 'No fair, %mainVillain% and %sideVillain% still chewing!',
        dailyChallengeWin2: '%mainVillain% and %sideVillain%  are too full!',
        villainYOffsetMultipler: 0.7,
      },
      tutorialSpeech: {
        hard: {
          pre_win_saga_map: [
            {
              source: 'gingy',
              text: 'Oh no! %mainVillain% is here to cause trouble!',
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'villain',
              index: 1,
              subIndex: 1,
              text: '%mainVillain% hungry! Plants here look so yummy!',
              x: 50,
              y: 20,
              pos: 'top-left',
            },
          ],
          level_window: [
            {
              source: 'villain',
              index: 1,
              subIndex: 4,
              text: '%mainVillain% is here to eat, you no stop %mainVillain%!',
              x: 50,
              y: 20,
              pos: 'left',
              duration: 2000,
            },
            {
              source: 'gingy',
              text: 'You can use additional boosters on hard levels!',
              x: 50,
              y: 80,
            },
          ],
          post_corruption_level_window: [
            {
              source: 'villain',
              index: 1,
              subIndex: 4,
              text: 'Get out of %mainVillain%\'s way!|Now %mainVillain% is hungry and angry!|Plants go in %mainVillain%\'s belly! Now!',
              x: 50,
              y: 20,
              pos: 'left',
            },
          ],
        },
        super_hard: {
          pre_win_saga_map: [
            {
              source: 'gingy',
              text: "Looks like %mainVillain% brought a dinner guest! It's %sideVillain%!",
              x: 50,
              y: 80,
              clickable: true,
            },
            {
              source: 'villain',
              index: 1,
              subIndex: 1,
              text: '%mainVillain% and %sideVillain% are ready to eat!',
              x: 50,
              y: 20,
              pos: 'top-left',
              clickable: true,
            },
            {
              source: 'villain',
              index: 2,
              subIndex: 4,
              text: 'Get out of %sideVillain%\'s way! Unless you wanna get eaten too!',
              x: 50,
              y: 20,
              pos: 'top-right',
            },
          ],
          level_window: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [4, 4],
              text: 'Get ready for a feeding frenzy!',
              x: 50,
              y: 20,
              pos: 'double',
              duration: 2000,
            },
            {
              source: 'gingy',
              text: 'Using extra boosters will help us defeat them!',
              x: 50,
              y: 80,
            },
          ],
          post_corruption_level_window: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [4, 4],
              text: 'Time for the main course!|%mainVillain% and %sideVillain% eat you whole!|Plants go in %mainVillain%\'s belly! Now!',
              x: 50,
              y: 20,
              pos: 'double',
            },
          ],
          post_win_saga_map: [
            {
              source: 'gingy',
              text: 'Good job, you defeated %mainVillain% and %sideVillain%! We are safe for now!',
              x: 50,
              y: 80,
            },
          ],
        },
        dailyChallenge: {
          sagaMap: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'Look! %sideVillain%! They back!',
              pos: 'left',
              x: 50,
              y: 10,
              duration: 3000,
            },
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'Don\'t talk with mouth full %mainVillain%!',
              pos: 'right',
              x: 50,
              y: 10,
              duration: 3000,
            },
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'They looking to challenge us!',
              pos: 'left',
              x: 50,
              y: 10,
              duration: 3000,
            },
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'It\'s time for a buffet! ',
              pos: 'right',
              x: 50,
              y: 10,
              duration: 3000,
            },
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: '%mainVillain loves buffets!',
              pos: 'left',
              x: 50,
              y: 10,
              duration: 3000,
            },
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'Let\'s eat!',
              pos: 'double',
              x: 50,
              y: 10,
              duration: 3000,
            },
          ],
          sagaMapRetry0: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'Thanks for the food!',
              pos: 'double',
              x: 50,
              y: 10,
            },
          ],
          sagaMapRetry1: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: 'It\'s time for dinner!',
              pos: 'double',
              x: 50,
              y: 10,
            },
          ],
          sagaMapRetry2: [
            {
              source: 'villain',
              index: [1, 2],
              subIndex: [1, 1],
              text: '%mainVillain% and %sideVillain% always hungry!',
              pos: 'double',
              x: 50,
              y: 10,
            },
          ],
        },
      },
    },
  },
};
